import {
    Component,
    Input,
    Output,
    EventEmitter,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    ElementRef,
    HostListener,
    signal,
} from "@angular/core";
import { S25IconModule } from "../s25-icon/s25.icon.module";
import { TypeManagerDecorator } from "../../main/type.map.service";

@TypeManagerDecorator("s25-ng-sidebar")
@Component({
    selector: "s25-ng-sidebar",
    template: `
        <button class="aw-button aw-button--outline" (click)="open()">{{ buttonText }}</button>
        <div class="sidebar-overlay" [class.visible]="isOpen()" (click)="close()"></div>
        <div class="sidebar" [class.open]="isOpen()">
            <div class="sidebar-header">
                <h2>{{ title }}</h2>
                <button class="s25-modal--close" (click)="close()" [disabled]="!isOpen()">
                    <s25-ng-icon [type]="'close'"></s25-ng-icon>
                </button>
            </div>

            <div class="sidebar-content">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styles: [
        `
            :host {
                display: block;
            }

            .sidebar-overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 1000;
                opacity: 0;
                visibility: hidden;
                transition:
                    opacity 0.3s ease,
                    visibility 0.3s ease;
            }

            .sidebar-overlay.visible {
                opacity: 1;
                visibility: visible;
            }

            .sidebar {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                width: 400px;
                background-color: white;
                box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
                z-index: 1001;
                transform: translateX(100%);
                transition: transform 0.3s ease;
                display: flex;
                flex-direction: column;
            }

            .sidebar.open {
                transform: translateX(0);
            }

            .sidebar-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 1rem;
            }

            .sidebar-content {
                flex: 1;
                padding: 1rem;
                overflow-y: auto;
            }
        `,
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.Emulated,
    imports: [S25IconModule],
})
export class S25SidebarComponent {
    @Input() title = "";
    @Input() buttonText = "";

    @Output() closed = new EventEmitter<void>();

    isOpen = signal<boolean>(false);

    @HostListener("document:keydown.escape")
    handleEscape() {
        if (this.isOpen()) {
            this.close();
        }
    }

    constructor(private elementRef: ElementRef) {}

    open() {
        this.isOpen.set(true);
        setTimeout(() => {
            // close button is disabled when sidebar closed to avoid keyboard focus - focus after slight delay when opening to allow for button to enable
            this.elementRef.nativeElement.querySelector(".s25-modal--close")?.focus();
        });
    }

    close() {
        this.isOpen.set(false);
        this.closed.emit();
    }
}
